import {toTop, toBottom} from 'Utils/scrollUtils';

const topClickEventHandler = event => {
    event.preventDefault();

    const target = event.srcElement || event.target;

    toTop(parseInt(target.getAttribute('data-behavior-scroll-timing') || 250, 10));
};

const bottomClickEventHandler = event => {
    event.preventDefault();

    const target = event.srcElement || event.target;

    toBottom(parseInt(target.getAttribute('data-behavior-scroll-timing') || 250, 10));
};

const attrChangeEventHandler = () => {
    unregister();
    register();
};

/**
 * @description Unregister scroll behavior on all element(s) with data-behavior-scroll attribute.
 */
export const unregister = () => {
    const nodes = [...document.querySelectorAll('[data-behavior-scroll]')];

    nodes.forEach(node => {
        node.removeEventListener('click', topClickEventHandler);
        node.removeEventListener('click', bottomClickEventHandler);
        node.removeEventListener('DOMAttrModified', attrChangeEventHandler);

        if(node.observer) {
            node.observer.disconnect();
        }
    });
};

/**
 * @description Register scroll behavior on all element(s) with data-behavior-scroll attribute.
 */
export const register = () => {
    const nodes = [...document.querySelectorAll('[data-behavior-scroll]')];

    nodes.forEach(node => {
        if(typeof MutationObserver !== 'undefined') {
            node.observer = node.observer || new MutationObserver(attrChangeEventHandler);
            node.observer.observe(node, {attributes: true});
        } else {
            node.addEventListener('DOMAttrModified', attrChangeEventHandler, false);
        }

        const scrollType = node.getAttribute('data-behavior-scroll');

        if(scrollType === 'top') {
            node.addEventListener('click', topClickEventHandler);
        } else if(scrollType === 'bottom') {
            node.addEventListener('click', bottomClickEventHandler);
        }
    });
};

